import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectLoading, selectVAT } from './store/slice'
import { getVAT } from './store/thunk'

const useGetVAT = (disableCallApi) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectLoading(keyLoading.VAT))
  const vatPercentage = useSelector(selectVAT)

  useEffect(() => {
    if (!disableCallApi) {
      dispatch(getVAT())
    }
  }, [])

  return {
    loading,
    vatPercentage,
  }
}

export default useGetVAT
